import OverallTable from "./overallTable.container";

export default OverallTable;